module.exports = __webpack_public_path__ + "img/privacy.50cdcbaf.png";